import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'antd';
import useApi from '../../hooks/useApi';
import { isEmpty } from '../../generalFunctions';

const PhotoGallary = () => {
    const [response, request] = useApi("/website/home/images");
    const [photos, setPhotos] = useState([]);

    useEffect(() => {
        request();
    }, []);//eslint-disable-line

    useEffect(() => {
        if (!isEmpty(response.data) && !response.error && !response.isLoading) {
            setPhotos(response.data);
        }
    }, [response]);

    return (
        <Row gutter={[32, 32]}>
            {photos.map(photo => <Col span={24} key={photo.id}>
                <Card title={photo.title}>
                    <Row gutter={[32, 32]}>
                        {photo.images.map(image => <Col xl={12} lg={12} md={24} sm={24} xs={24}>
                            <Card
                                key={image.id}
                                hoverable
                                bodyStyle={{ padding: 0 }}
                                cover={<img alt={image.name} src={image.path} style={{ height: 300, objectFit: 'scale-down' }} />}
                            >
                            </Card>
                        </Col>
                        )}
                    </Row>
                </Card>
            </Col>)}
        </Row>
    );
}

export default PhotoGallary;